// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37GAA","title":"styles_title__2RFUd"};